var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_1362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21326 1.10693C8.59839 1.10679 7.99204 1.25068 7.4428 1.52707C6.89356 1.80346 6.41669 2.20466 6.05042 2.69852C5.68415 3.19239 5.43865 3.76518 5.33361 4.37101C5.22856 4.97683 5.26688 5.59884 5.44551 6.18718L0.900757 10.7319V13.3569H3.52576L8.07051 8.81218C8.61209 8.97658 9.18275 9.02228 9.74359 8.94618C10.3044 8.87008 10.8423 8.67397 11.3205 8.3712C11.7987 8.06844 12.206 7.66614 12.5146 7.19173C12.8233 6.71732 13.026 6.18194 13.1091 5.62208C13.1921 5.06222 13.1535 4.49104 12.9958 3.94747C12.8381 3.40389 12.5651 2.9007 12.1953 2.47218C11.8256 2.04366 11.3678 1.69989 10.8532 1.46429C10.3386 1.22869 9.77924 1.1068 9.21326 1.10693ZM9.21326 8.10693C8.91204 8.10677 8.6125 8.06225 8.32426 7.97481L7.82244 7.82256L7.45188 8.19312L6.06019 9.58481L5.45688 8.98193L4.83826 9.60056L5.44157 10.2039L4.74769 10.8977L4.14438 10.2944L3.52576 10.9131L4.12907 11.5164L3.16351 12.4819H1.77576V11.0942L6.06413 6.80581L6.43513 6.43525L6.28288 5.93343C6.09589 5.31699 6.10803 4.65728 6.3176 4.04814C6.52716 3.43901 6.92347 2.91146 7.45015 2.54054C7.97683 2.16963 8.60705 1.97424 9.25118 1.98217C9.89532 1.99009 10.5205 2.20093 11.0379 2.58469C11.5553 2.96844 11.9385 3.50558 12.1331 4.11969C12.3276 4.7338 12.3235 5.39361 12.1214 6.00526C11.9193 6.61692 11.5294 7.14927 11.0073 7.52659C10.4852 7.90391 9.85744 8.10699 9.21326 8.10693Z",
    fill: "#1B2559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65076 5.48193C10.134 5.48193 10.5258 5.09018 10.5258 4.60693C10.5258 4.12368 10.134 3.73193 9.65076 3.73193C9.16751 3.73193 8.77576 4.12368 8.77576 4.60693C8.77576 5.09018 9.16751 5.48193 9.65076 5.48193Z",
    fill: "#1B2559"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_1362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.0257568 0.231934)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon-03.499c565814e68f74f2cd8883cc90cc08.svg";
export { ForwardRef as ReactComponent };